import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import config from "../utilities/config";
import { Link } from "react-router-dom";
import { Toast } from "../../src/components/Atoms/Toast";
import {
  isMobile,
  isTablet,
  isBrowser,
  isSmartTV,
  deviceType,
  osName
} from 'react-device-detect';

import { CartItemAddToWishList } from "../utilities/api";
import constants from "../utilities/constants";
import { getAuthModalType } from "../redux/action/authAction";
import { Helmet } from 'react-helmet';
import {
  fetchSEOData,
  intProductListItem,
  product_list_filter,
  product_list_item,
} from "../redux/action/productAction";

import {
  getImage,
  formatCurrencywithamount,
  findCategoryByValue,
  filterSortFromURl,
  filterSortByArrayBasedOnUrl,
  changePriceValue,
} from "../utilities/helper";
import { Range } from "react-range";
import { isEmptyArray } from "formik";
import Modal from "react-modal";
// import Pagination from "../components/Pagenation";
import ReactPaginate from "react-paginate";
import {
  getPersionalData,
  removewishlistfromstore,
} from "../redux/action/myAccountAction";
import isEqual from "lodash.isequal";
import { ACTION_TYPE } from "../redux/action/type";
import { useNavigate } from "react-router-dom";

function ProductList() {
  const navigate = useNavigate();

  const url = new URL(window.location.href);
  const params = url.searchParams;

  const [showImage, setShowImage] = useState(false);

  useEffect(() => {
    if (!params.has("sort")) {
      navigate(constants.ADDITIONAL_PATH + constants.CLEAR_FILTER_REDIRECT_PATH, { replace: false });
    }
  }, []);


  const { selectedcountrySuccess, dailyMetalPriceSuccess } = useSelector(
    (state) => state.homeReducer
  );
  const [priceRange, setPriceRange] = useState([
    0,
    (selectedcountrySuccess?.currencyAlias
      ? selectedcountrySuccess?.currencyAlias
      : "") == constants.INR
      ? 200000
      : 5000,
  ]);
  const [getSeoData, setSeoData] = useState(null);
  const [likedProducts, setLikedProducts] = useState({});
  const [Category, setCategory] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({
    Collection: null,
    Theme: null,
    Occasion: null,
    Style: null,
    Finish: null,
    "Product Type": null,
    "Sort By": null,
    price: {
      min_price:
        (selectedcountrySuccess?.currencyAlias
          ? selectedcountrySuccess?.currencyAlias
          : "") == constants.INR
          ? priceRange[0]
          : priceRange[0] * selectedcountrySuccess?.fxConversionRate,
      max_price:
        (selectedcountrySuccess?.currencyAlias
          ? selectedcountrySuccess?.currencyAlias
          : "") == constants.INR
          ? priceRange[1]
          : priceRange[1] * selectedcountrySuccess?.fxConversionRate,
    },
  });
  const hasRunOnce = useRef(false);
  const productListLoading = useRef(false);
  const productList = useRef(null);

  const prevValuesFilter = useRef(null);
  const [offSet, SetOffset] = useState(0);
  const [apiTotalCount, setAPITotalCount] = useState(0);
  const limit = 36; // Items per page

  const [itemOffset, setItemOffset] = useState(0);
  const [filters, setfilters] = useState([]);
  const [isMobileFilter, setIsMobileFilter] = useState(false);
  const [finalPriceRange, setFinalPriceRange] = useState([
    0,
    (selectedcountrySuccess?.currencyAlias
      ? selectedcountrySuccess?.currencyAlias
      : "") == constants.INR
      ? 200000
      : 5000,
  ]);
  const [selectedValue, setSelectedValue] = useState("Sort By");
  const [metatitle, setmetatitle] = useState("");
  const [metadescription, setmetadescription] = useState("");
  const [metakeyword, setmetakeyword] = useState("");
  const [metaseotext, setmetaseotext] = useState("");
  const [seourl, setseourl] = useState("");
  const [allattriButeValue, setAllattriButeValue] = useState(null);
  const [title, settitle] = useState("");
  const clear = "clear";

  const prevSeoDataRef = useRef(null);

  const handlePriceChange = (values) => {
    SetOffset(0);
    setItemOffset(0);
    setPriceRange(values);
  };
  const handleFinalPriceChange = (values) => {
    SetOffset(0);
    setItemOffset(0);

    productListLoading.current = false;

    setFinalPriceRange(values); // Update only after final selection
    // config.logGeneral && console.log("=====>handleFinalPriceChange");
  };
  const [expandedCategories, setExpandedCategories] = useState([]);

  const dispatch = useDispatch();
  const filterList = [
    "Collection",
    "Theme",
    "Occasion",
    "Style",
    "Finish",
    "Product Type",
    "Sort By",
  ];
  // Handle filter change
  // const handleFilterChange = (category, value) => {
  //   SetOffset(0);
  //   setItemOffset(0);

  //   setSelectedFilters((prevState) => {
  //     // If the same item is selected, unselect it
  //     const newSelection = prevState[category] === value ? null : value;
  //     return { ...prevState, [category]: newSelection };
  //   });
  //   productListLoading.current = false;
  // };

  const handleFilterChange = (category, value) => {
    SetOffset(0);
    setItemOffset(0);

    setSelectedFilters((prevState) => {
      if (category === "Sort By") {
        // For "Sort By", replace the value instead of toggling
        return {
          ...prevState,
          [category]: value,
        };
      } else {
        const currentValues = prevState[category] || [];

        const valueExists = currentValues.includes(value);

        const updatedValues = valueExists
          ? currentValues.filter((v) => v !== value) // Remove value
          : [...currentValues, value]; // Add value

        return {
          ...prevState,
          [category]: updatedValues,
        };
      }
    });

    productListLoading.current = false;
  };

  const handleChange = (event) => {
    const selectedOption = event.target.value;
    setSelectedValue(selectedOption); // Update the selected value

    // Find the corresponding category and option
    const selectedCategory = filterList[6]; // Since you're slicing 6-7, it's always 6th item
    const option = filters[selectedCategory]?.find(
      (item) => item.name === selectedOption
    );

    // Trigger onChange only if valid option is selected
    if (option) {
      handleOnchange(selectedCategory, option);
    }
  };

  const toggleCategory = (category) => {
    setExpandedCategories((prev) =>
      prev.includes(category)
        ? prev.filter((c) => c !== category)
        : [...prev, category]
    );
  };
  // const [skuId,setskuId]=(null)
  const { userProfile_id } = useSelector((state) => state.authReducer);

  const {
    //wishlist

    wishListDataSuccess,
  } = useSelector((state) => state.myAccountReducer);

  config.logGeneral && console.log("===>selectedFilterstest", selectedFilters);
  const descriptionShow = (description) => {
    const maxLength = isMobile || isTablet ? 15 : 30;
    return description.length > maxLength ? description.slice(0, maxLength - 1) + ".." : description;
  };

  const { productListResponseSuccess, productListResponesLoading } =
    useSelector((state) => state.productFilterListReducer);

  useEffect(() => {
    if (Object.keys(productListResponseSuccess).length > 0) {
      config.logGeneral &&
        config.logGeneral &&
        console.log(
          "productListResponseSuccess1234",
          productListResponseSuccess
        );
      // meta title
      var metatitle_raw = (productListResponseSuccess?.meta_title || []).filter(e => e !== null).join("");//meta_title
      var metadescription_raw = (productListResponseSuccess?.meta_description || []).filter(e => e !== null).join(" ");
      var metaseourl_raw = productListResponseSuccess?.seo_url;
      var meta_keyword = (productListResponseSuccess?.meta_keyword || []).filter(e => e !== null).join(" ");
      var metaseotext_raw = productListResponseSuccess?.seo_text;
      if (metadescription_raw) {
        setmetadescription(metadescription_raw)
      }
      if (meta_keyword) {
        setmetakeyword(meta_keyword)
      }
      if (metaseotext_raw) {
        setmetaseotext(metaseotext_raw)
      }
      if (metaseourl_raw) {
        setseourl(metaseourl_raw)
      }
      config.logGeneral && console.log(metatitle_raw, "metatitle_raw888")
      var filtersNew = filterList?.reduce((acc, filterType) => {
        acc[filterType] = productListResponseSuccess[filterType] || [];
        return acc;
      }, {});
      config.logGeneral &&
        config.logGeneral &&
        console.log(getSeoData, filters.length, "======>filtersyy");
      // if (filters.length > 0) {
      //   productListLoading.current = false;
      // }
      setfilters({
        ...filtersNew,
        "Sort By": [
          { name: "New to Stylori" },
          // { name: "Featured" },
          { name: "Price Low to High" },
          { name: "Price High to Low" },
          // { name: "Ready to Ship" },
          { name: "Best Seller" },
        ],
      });
      var titlte = productListResponseSuccess?.title_h1?.filter(
        (e) => e !== null
      );
      var title_display = titlte.join(" ");
      settitle(title_display);

      if (getSeoData !== null) {
        const category = getSeoData?.map((item) => {
          return findCategoryByValue(item, filtersNew, allattriButeValue);
        });

        setCategory(
          category
            ?.flat()
            .filter(
              (item, index, self) =>
                index ===
                self.findIndex(
                  (t) =>
                    t.attributeName === item.attributeName &&
                    t.attributeValue === item.attributeValue
                )
            )
        );
      }
    }
  }, [productListResponseSuccess]);

  const {
    productListitemsResponseSuccess,

    productListitemsResponesLoading,
  } = useSelector((state) => state.productFilterListitemsReducer);

  config.logGeneral &&
    config.logGeneral &&
    console.log("==>selectedcountrySuccess123", selectedcountrySuccess);

  const productsToDisplay =
    productListitemsResponseSuccess?.data?.allProductLists || [];
  config.logGeneral &&
    config.logGeneral &&
    console.log(
      "==>productListitemsResponseSuccess123",
      productListitemsResponseSuccess
    );

  useEffect(() => {
    if (productListitemsResponseSuccess?.data?.totalCount) {
      setAPITotalCount(productListitemsResponseSuccess?.data?.totalCount);
    }
  }, [productListitemsResponseSuccess]);

  useEffect(() => {
    const result = {};
    wishListDataSuccess?.forEach((wish) => {
      result[wish.productid] = 1;
    });
    setLikedProducts(result);
  }, [wishListDataSuccess]);

  const handleAddToWishlist = (productSku, productId) => {
    // Toggle the liked status for the specific product
    config.logGeneral &&
      config.logGeneral &&
      console.log(
        likedProducts,
        "uyttree",
        productSku,
        "productSku",
        productId,
        "productId"
      );
    var alreadyExsists = likedProducts?.hasOwnProperty(productId);
    if (!userProfile_id) {
      dispatch(getAuthModalType(constants.Login));
      return;
    }
    if (alreadyExsists) {
      //remove from wishlsit
      delete likedProducts[productId];
      dispatch(
        removewishlistfromstore(
          userProfile_id,
          productId,
          productSku,
          wishListDataSuccess
        )
      );
      Toast("Product removed from wishlist successfully", "success");
      // dispatch(getPersionalData(userProfile_id));
    } else {
      // add to wishlist
      setLikedProducts((prevLikedProducts) => ({
        ...prevLikedProducts,
        [productId]: !prevLikedProducts[productId],
      }));
      // Call API to add the product to the wishlist
      CartItemAddToWishList(userProfile_id, productSku, productId)
        .then((response) => {
          // Remove the item from cart after adding it to the wishlist
          dispatch(getPersionalData(userProfile_id));
          Toast("Product Added to wishlist successfully", "success");
        })
        .catch((error) => {
          // Handle any errors
          config.logGeneral &&
            console.error("Error adding item to wishlist:", error);
        });
    }
  };

  // Scroll to Top
  const handleScroll = () => {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    const scrollPosition = scrollTop + windowHeight;

    // Show image if user is in the middle or bottom of page
    if (scrollPosition > documentHeight / 2) {
      setShowImage(true);
    } else {
      setShowImage(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);



  //SEO Data Reducer
  const { getSEODataResponseSuccess } = useSelector(
    (state) => state.getSEODataReducer
  );
  //SEO Data for Filter
  useEffect(() => {
    // dispatch({ type: ACTION_TYPE.GET_PRODUCT_FILTER_LIST_DATA_REQUEST });

    let pathnameSplit = window?.location?.pathname?.split(
      constants.ADDITIONAL_PATH + "/"
    );
    const splitHiphen = () => {
      if (pathnameSplit[1]?.indexOf("-")) {
        return pathnameSplit[1].split("-");
      }
    };
    const condition = { seofilter: { seoUrl: { in: splitHiphen() } } };
    config.logGeneral && console.log("===>fetchSEOData");

    // config.logGeneral && console.log(condition, "getSEODatacondition");
    dispatch(intProductListItem());
    dispatch(fetchSEOData(condition));

    // setCategory([]);
    setSelectedFilters({
      Collection: null,
      Theme: null,
      Occasion: null,
      Style: null,
      Finish: null,
      "Product Type": null,
      "Sort By": null,
      price: {
        min_price:
          (selectedcountrySuccess?.currencyAlias
            ? selectedcountrySuccess?.currencyAlias
            : "") == constants.INR
            ? priceRange[0]
            : priceRange[0] * selectedcountrySuccess?.fxConversionRate,
        max_price:
          (selectedcountrySuccess?.currencyAlias
            ? selectedcountrySuccess?.currencyAlias
            : "") == constants.INR
            ? priceRange[1]
            : priceRange[1] * selectedcountrySuccess?.fxConversionRate,
      },
    });
  }, [window.location.href]);

  // Update `selectedFilters` whenever `priceRange` changes
  useEffect(() => {
    if (!isEqual(finalPriceRange, productList.current)) {
      productList.current = finalPriceRange;
      const timer = setTimeout(() => {
        setSelectedFilters((prevFilters) => ({
          ...prevFilters,
          price: {
            min_price:
              (selectedcountrySuccess?.currencyAlias
                ? selectedcountrySuccess?.currencyAlias
                : "") == constants.INR
                ? finalPriceRange[0]
                : finalPriceRange[0] * selectedcountrySuccess?.fxConversionRate,
            max_price:
              (selectedcountrySuccess?.currencyAlias
                ? selectedcountrySuccess?.currencyAlias
                : "") == constants.INR
                ? finalPriceRange[1]
                : finalPriceRange[1] * selectedcountrySuccess?.fxConversionRate,
          },
        }));
      }, 500);

      // productListLoading.current = false;
      // const timer2 = setTimeout(() => {
      // }, 1000);
      config.logGeneral &&
        config.logGeneral &&
        console.log("===>selectedfinalPriceRange", finalPriceRange);
      return () => {
        clearTimeout(timer);
        // clearTimeout(timer2);
      };
    }
  }, [finalPriceRange]);
  // min_price: formatCurrencywithamount(
  //   finalPriceRange[0],
  //   (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
  //   (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
  //   dailyMetalPriceSuccess?.data?.allMasterCountries?.nodes
  // ),
  // max_price: formatCurrencywithamount(
  //   finalPriceRange[1],
  //   (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
  //   (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
  //   dailyMetalPriceSuccess?.data?.allMasterCountries?.nodes
  // ),
  useEffect(() => {
    if (selectedcountrySuccess !== null) {
      setPriceRange([
        changePriceValue(
          filterSortFromURl(window?.location?.search)?.startprice,
          filterSortFromURl(window?.location?.search)?.endprice,
          (selectedcountrySuccess?.currencyAlias
            ? selectedcountrySuccess?.currencyAlias
            : "") == constants.INR,
          selectedcountrySuccess?.fxConversionRate
        ).startprice,
        changePriceValue(
          filterSortFromURl(window?.location?.search)?.startprice,
          filterSortFromURl(window?.location?.search)?.endprice,
          (selectedcountrySuccess?.currencyAlias
            ? selectedcountrySuccess?.currencyAlias
            : "") == constants.INR,
          selectedcountrySuccess?.fxConversionRate
        ).endprice,
      ]);
      setFinalPriceRange([
        changePriceValue(
          filterSortFromURl(window?.location?.search)?.startprice,
          filterSortFromURl(window?.location?.search)?.endprice,
          (selectedcountrySuccess?.currencyAlias
            ? selectedcountrySuccess?.currencyAlias
            : "") == constants.INR,
          selectedcountrySuccess?.fxConversionRate
        ).startprice,
        changePriceValue(
          filterSortFromURl(window?.location?.search)?.startprice,
          filterSortFromURl(window?.location?.search)?.endprice,
          (selectedcountrySuccess?.currencyAlias
            ? selectedcountrySuccess?.currencyAlias
            : "") == constants.INR,
          selectedcountrySuccess?.fxConversionRate
        ).endprice,
      ]);
    }
  }, [selectedcountrySuccess]);

  config.logGeneral &&
    config.logGeneral &&
    console.log("productListLoadingtest", productListLoading.current);

  config.logGeneral &&
    config.logGeneral &&
    console.log(
      "======>initProductListtest",
      productListitemsResponesLoading,
      productListitemsResponseSuccess,
      productListLoading.current,
      allattriButeValue,
      !isMobileFilter
    );
  useEffect(() => {
    config.logGeneral &&
      console.log("chkfilterquerryy", productListLoading.current);
    // if (Object.keys(selectedFilters).length >= 7 && !isMobileFilter) {

    if (
      !productListLoading.current &&
      allattriButeValue !== null &&
      !isMobileFilter &&
      filterSortFromURl(window?.location?.search) !== null
    ) {
      productListLoading.current = true;
      dispatch(intProductListItem());
      initProductList();
    }
  }, [selectedFilters, offSet, allattriButeValue]);
  config.logGeneral &&
    config.logGeneral &&
    console.log(
      "allattriButeValuelistchecking",
      selectedFilters,
      "productListLoading.current ",
      productListLoading.current,
      "selectedFilters",
      selectedFilters,
      offSet
    );

  config.logGeneral &&
    config.logGeneral &&
    console.log(
      "productListitemsResponesLoading",
      productListitemsResponesLoading,
      "productListResponesLoading",
      productListResponesLoading,
      "filters",
      filters,
      "selectedFilters",
      selectedFilters,
      "allattriButeValue",
      allattriButeValue,
      "productListitemsResponseSuccess",
      productListitemsResponseSuccess
    );

  // const sorbyChange = (category, mobile = null) => {
  //   setSelectedFilters((prev) => ({
  //     ...prev,
  //     [category]: null,
  //   }));
  //   if (category == "Sort By") {
  //     setSelectedValue("Sort By");
  //   }

  //   if (mobile == null) {
  //     productListLoading.current = false;
  //   }
  // };
  const sorbyChange = (category, itemToRemove = null) => {
    setSelectedFilters((prev) => {
      const current = prev[category];
      console.log("Before:", prev,current.length);

      if (Array.isArray(current)) {
        const updatedArray = current.filter((item) => item !== itemToRemove);
        const updated = {
          ...prev,
          [category]: updatedArray.length > 0 ? updatedArray : null,
        };
        productListLoading.current = true;
        // // Filter and create a cleaned object
        // const cleanedFilters = Object.fromEntries(
        //   Object.entries(updated).filter(([key, value]) => {
        //     // Keep non-attribute fields like Sort By or price
        //     if (key === "Sort By" || key === "price") return true;

        //     // Check if the key exists in attribute list
        //     const exists = allattriButeValue.some(attr => attr.attributeName === key);
        //     return exists;
        //   })
        // );

        config.logGeneral && console.log("After:", updated);
        dispatch(product_list_item(updated, offSet));
        return updated;
      }

      const updated = {
        ...prev,
        [category]: null,
      };
      console.log("After:", updated);
      dispatch(product_list_item(updated, offSet));
      return updated;
    });

    // Reset sort option if necessary
    if (category === "Sort By") {
      setSelectedValue("Sort By");
    }

    // Control loading flag
    if (itemToRemove === null) {
      productListLoading.current = false;
    }
  };

  // filterSortFromURl(window?.location?.search)
  function initProductList(clear = null) {
    // if(allattriButeValue.length > 0){
    //   //dispatch(product_listing_loading());
    config.logGeneral && console.log("===>initinside");

    const hasChanged = !isEqual(prevValuesFilter.current, selectedFilters);
    config.logGeneral && console.log("===>initProductListclear", hasChanged);
    if (clear !== null) {
      setSelectedFilters({
        Collection: null,
        Theme: null,
        Occasion: null,
        Style: null,
        Finish: null,
        "Product Type": null,
        "Sort By": null,
        price: {
          min_price:
            (selectedcountrySuccess?.currencyAlias
              ? selectedcountrySuccess?.currencyAlias
              : "") == constants.INR
              ? priceRange[0]
              : priceRange[0] * selectedcountrySuccess?.fxConversionRate,
          max_price:
            (selectedcountrySuccess?.currencyAlias
              ? selectedcountrySuccess?.currencyAlias
              : "") == constants.INR
              ? priceRange[1]
              : priceRange[1] * selectedcountrySuccess?.fxConversionRate,
        },
      });
      //sorbyChange("Sort By");
      //window.location.replace(constants.ADDITIONAL_PATH+constants.CLEAR_FILTER_REDIRECT_PATH);
    }

    if (!isEmptyArray(productListResponseSuccess)) {
      selectedFilters.price.min_price =
        (selectedcountrySuccess?.currencyAlias
          ? selectedcountrySuccess?.currencyAlias
          : "") === constants.INR
          ? finalPriceRange[0]
          : finalPriceRange[0] * selectedcountrySuccess?.fxConversionRate;
      selectedFilters.price.max_price =
        (selectedcountrySuccess?.currencyAlias
          ? selectedcountrySuccess?.currencyAlias
          : "") === constants.INR
          ? finalPriceRange[1]
          : finalPriceRange[1] * selectedcountrySuccess?.fxConversionRate;

      // Filter and create a cleaned object
      const cleanedFilters = Object.fromEntries(
        Object.entries(selectedFilters).filter(([key, value]) => {
          // Keep non-attribute fields like Sort By or price
          if (key === "Sort By" || key === "price") return true;

          // Check if the key exists in attribute list
          const exists = allattriButeValue.some(attr => attr.attributeName === key);
          return exists;
        })
      );

      dispatch(product_list_item(cleanedFilters, offSet));
      if (isMobileFilter) {
        closeModal();
      }
    }
  }

  const handleOnchange = (filterCategory, option) => {
    handleFilterChange(filterCategory, option.name);
    toggleCategory(filterCategory);
  };

  useEffect(() => {
    const currentSeoNodes =
      getSEODataResponseSuccess?.data?.allSeoUrlPriorities?.nodes;
    if (!currentSeoNodes || currentSeoNodes.length === 0) return;
    dispatch({ type: ACTION_TYPE.GET_SEO_DATA_REQUEST });

    const hasChanged = !isEqual(prevSeoDataRef.current, currentSeoNodes);
    if (hasChanged) {
      setCategory([]);
      prevSeoDataRef.current = currentSeoNodes;
      dispatch({ type: ACTION_TYPE.GET_PRODUCT_FILTER_LIST_DATA_REQUEST });

      // initProductList();

      config.logGeneral && console.log("=====>prevSeoDataReftest");
    }
    if (
      !isEmptyArray(
        getSEODataResponseSuccess?.data?.allSeoUrlPriorities?.nodes
      ) &&
      getSEODataResponseSuccess?.data?.allSeoUrlPriorities?.nodes !== undefined
    ) {
      dispatch(
        product_list_filter(
          getSEODataResponseSuccess?.data?.allSeoUrlPriorities?.nodes
        )
      );
      setSeoData(
        getSEODataResponseSuccess?.data?.allSeoUrlPriorities?.nodes?.map(
          (item) => item.attributeValue
        )
      );
      setAllattriButeValue(
        getSEODataResponseSuccess?.data?.allSeoUrlPriorities?.nodes
      );
    }
  }, [getSEODataResponseSuccess]);
  // setPriceRange([
  //   filterSortFromURl(window?.location?.search)?.startprice ?? 0,
  //   (filterSortFromURl(window?.location?.search)?.endprice ?? 0) == 0 ||
  //   filterSortFromURl(window?.location?.search)?.endprice >
  //     changePriceValue(
  //       (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : '') == constants.INR
  //     )
  //     ? (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : '') == constants.INR
  //       ? 200000
  //       : 5000
  //     : (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : '') == constants.INR
  //     ? filterSortFromURl(window?.location?.search)?.endprice
  //     : selectedcountrySuccess?.fxConversionRate *
  //       filterSortFromURl(window?.location?.search)?.endprice,
  // ]);

  useEffect(() => {
    if (!hasRunOnce.current && !isEmptyArray(Category)) {
      hasRunOnce.current = true;
      Category?.push({
        attributeName: "Sort By",
        attributeValue: filterSortFromURl(window?.location?.search)?.sort,
      });
      setSelectedValue(filterSortFromURl(window?.location?.search)?.sort);
      Category?.map((item) => {
        handleFilterChange(item.attributeName, item.attributeValue);
        if (item.attributeName == "Sort By") {
          // setSelectedValue(item.attributeName);
        } else if (item.attributeName !== "Sort By") {
          toggleCategory(item.attributeName);
        }
      });

      config.logGeneral &&
        config.logGeneral &&
        console.log(
          "=========>categoryuseeffect",
          filterSortFromURl(window?.location?.search)?.startprice,
          filterSortFromURl(window?.location?.search)?.endprice
        );
      config.logGeneral &&
        config.logGeneral &&
        console.log(
          "=====>changePriceValuevalue",
          changePriceValue(
            filterSortFromURl(window?.location?.search)?.startprice,
            filterSortFromURl(window?.location?.search)?.endprice,
            (selectedcountrySuccess?.currencyAlias
              ? selectedcountrySuccess?.currencyAlias
              : "") == constants.INR,
            selectedcountrySuccess?.fxConversionRate
          ).startprice,
          changePriceValue(
            filterSortFromURl(window?.location?.search)?.startprice,
            filterSortFromURl(window?.location?.search)?.endprice,
            (selectedcountrySuccess?.currencyAlias
              ? selectedcountrySuccess?.currencyAlias
              : "") == constants.INR,
            selectedcountrySuccess?.fxConversionRate
          ).endprice
        );

      setPriceRange([
        changePriceValue(
          filterSortFromURl(window?.location?.search)?.startprice,
          filterSortFromURl(window?.location?.search)?.endprice,
          (selectedcountrySuccess?.currencyAlias
            ? selectedcountrySuccess?.currencyAlias
            : "") == constants.INR,
          selectedcountrySuccess?.fxConversionRate
        ).startprice,
        changePriceValue(
          filterSortFromURl(window?.location?.search)?.startprice,
          filterSortFromURl(window?.location?.search)?.endprice,
          (selectedcountrySuccess?.currencyAlias
            ? selectedcountrySuccess?.currencyAlias
            : "") == constants.INR,
          selectedcountrySuccess?.fxConversionRate
        ).endprice,
      ]);
      setFinalPriceRange([
        changePriceValue(
          filterSortFromURl(window?.location?.search)?.startprice,
          filterSortFromURl(window?.location?.search)?.endprice,
          (selectedcountrySuccess?.currencyAlias
            ? selectedcountrySuccess?.currencyAlias
            : "") == constants.INR,
          selectedcountrySuccess?.fxConversionRate
        ).startprice,
        changePriceValue(
          filterSortFromURl(window?.location?.search)?.startprice,
          filterSortFromURl(window?.location?.search)?.endprice,
          (selectedcountrySuccess?.currencyAlias
            ? selectedcountrySuccess?.currencyAlias
            : "") == constants.INR,
          selectedcountrySuccess?.fxConversionRate
        ).endprice,
      ]);
      productListLoading.current = false;
    } else if (
      !hasRunOnce.current &&
      isEmptyArray(Category) &
      filterSortByArrayBasedOnUrl().includes(
        filterSortFromURl(window?.location?.search)?.sort?.toLowerCase()
      )
    ) {
      hasRunOnce.current = true;
      productListLoading.current = false;

      handleFilterChange(
        "Sort By",
        filterSortFromURl(window?.location?.search)?.sort
      );
      setCategory([
        { "Sort By": filterSortFromURl(window?.location?.search)?.sort },
      ]);

      // setSelectedValue(filterSortFromURl(window?.location?.search)?.sort);
    }
  }, [Category]);
  // config.logGeneral && console.log("spliturlwithhref", window.location.search);

  useEffect(() => {
    hasRunOnce.current = false;
    productListLoading.current = false;
  }, [getSeoData]);

  // Modal
  const customStyles = {
    content: {
      top: "18%",
      left: "5%",
      right: "5%",
      bottom: "auto",
      transform: "translate(0%, 0%)",
      overflow: "auto",
    },
  };

  let subtitle;
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
    setIsMobileFilter(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = "#f00";
  }

  function closeModal() {
    setIsOpen(false);
    setIsMobileFilter(false);
  }
  const handlePageClick = (event) => {
    config.logGeneral && console.log("handlePageClick", event);
    // offset = event.selected * limit;
    const newOffset = (event.selected * 36) % 36;
    productListLoading.current = false;

    config.logGeneral &&
      config.logGeneral &&
      console.log(
        `User requested page number ${event.selected}, which is offset ${newOffset}`
      );
    setItemOffset(event.selected);
    SetOffset(event.selected * limit);
    window.scrollTo(0, 0);
  };


  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowImage(true);
      } else {
        setShowImage(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Helmet>
        <title>{metatitle}</title>
        <meta property="og:title" id="fb-title" content={metatitle} />
        <meta name="description" content={metadescription} />
        <meta name="keywords" content={metakeyword} />
        <meta property="og:site_name" content="Stylori" />
        <meta property="og:description" content={metadescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" id="fb-product-url" content={window.location.href} />
        <meta
          property="og:image"
          id="fb_imageUrl"
          content={
            productsToDisplay[0]?.productImagesByProductId[0]?.imageUrl || constants.DEFAULT_IMAGE
          }
        />
        <meta property="og:image:width" content="200" />
        <meta property="og:image:height" content="200" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@StyloriLove" /> <meta name="twitter:creator" content="@StyloriSilver"></meta>
        <meta name="twitter:title" id="twitter-title" content={seourl} />
        <meta name="twitter:description" content={metaseotext} />
        <meta
          name="twitter:image"
          content={
            productsToDisplay[0]?.productImagesByProductId[0]?.imageUrl || constants.DEFAULT_IMAGE
          }
        ></meta>
        <meta name="robots" content="index, follow" />
        <meta property="og:locale" content="en_US" />
      </Helmet>
      <body className="bg-white-100">
        <div className="container mx-auto p-4">
          <div className="flex justify-center items-center mb-5">
            <h1 className="font-tiemann font-medium lg:text-[40px] text-[24px] text-[#1a1a1a]">
              {title}
            </h1>
          </div>
          <div className="lg:flex lg:flex-col items-end relative gap-4 justify-center mb-5 hidden">
            <div className="relative">
              <select
                value={selectedValue}
                onChange={handleChange}
                className="appearance-none w-full px-4 py-2 border border-customGreen shadow-sm focus:outline-none focus:ring-2 focus:ring-customGreen focus:border-customGreen pr-10 bg-white"
              >
                <option disabled className=" text-black">
                  Sort By
                </option>
                {filterList?.slice(6, 7)?.map((filterCategory) =>
                  filters[filterCategory]?.map((option, idx) => (
                    <option key={idx} value={option.name}>
                      {option.name}
                    </option>
                  ))
                )}
              </select>
              <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                <img
                  src={
                    constants.DEFAULT_IMAGE + "/product_care_accortian_down.png"
                  }
                  className="w-4"
                />
              </div>
            </div>
          </div>
          <Link to={constants.ADDITIONAL_PATH + "/contactus"}>
            <button className="flex bg-white fixed top-1/2 transform rotate-[270deg] lg:-left-14 -left-12 rounded-bl-2xl rounded-br-2xl lg:py-2 lg:px-4 py-2 px-3 text-[#020307] font-tiemann font-medium tracking-wider lg:text-xl text-base shadow-md z-[1]">
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="transform rotate-[90deg] pt-1"
              >
                <path
                  d="M14.8063 1.4124C14.0725 1.88413 13.3649 2.35585 12.6311 2.82758C12.4739 2.9324 12.3691 2.9324 12.2118 2.82758C11.5042 2.35585 10.7967 1.91034 10.0891 1.43861C9.25045 0.888265 8.43803 1.17654 8.09734 2.11999C7.80906 2.9062 7.49458 3.6924 7.20631 4.47861C7.15389 4.63585 7.04906 4.71447 6.86562 4.71447C6.00079 4.74068 5.13596 4.79309 4.29734 4.84551C3.3801 4.89792 2.85596 5.6055 3.09182 6.49654C3.30148 7.33516 3.53734 8.17378 3.7732 8.98619C3.82562 9.16964 3.7732 9.27447 3.64217 9.40551C2.96079 9.92964 2.30561 10.48 1.65044 11.0041C0.916649 11.5807 0.916649 12.4717 1.65044 13.0745C2.30561 13.5986 2.96079 14.149 3.61596 14.6469C3.79941 14.7779 3.82562 14.909 3.7732 15.1186C3.53734 15.931 3.32769 16.7434 3.17044 17.32C2.90837 18.4469 3.35389 19.1283 4.29734 19.1807C5.16217 19.2331 6.027 19.2855 6.91803 19.3117C7.10148 19.3117 7.1801 19.3903 7.25872 19.5476C7.5732 20.36 7.88768 21.1724 8.20217 21.9848C8.54286 22.8234 9.35527 23.0855 10.1153 22.5876C10.8491 22.1158 11.5567 21.6441 12.2904 21.1724C12.4477 21.0676 12.5525 21.0676 12.736 21.1724C13.4698 21.6703 14.2036 22.1421 14.9635 22.6138C15.6711 23.0593 16.5098 22.771 16.8242 21.9848C17.1387 21.1724 17.4532 20.3338 17.7677 19.5214C17.8201 19.3379 17.9249 19.2855 18.1084 19.2855C18.947 19.2593 19.7594 19.1545 20.598 19.1545C21.4367 19.1545 22.1967 18.4207 21.8822 17.3986C21.6201 16.5862 21.4366 15.7738 21.2008 14.9614C21.1484 14.8041 21.1746 14.6993 21.3318 14.5945C22.0132 14.0441 22.6684 13.52 23.3498 12.9697C24.0835 12.3669 24.0835 11.5021 23.3498 10.9255C22.6684 10.3752 22.0132 9.85103 21.3318 9.30069C21.2008 9.19586 21.1484 9.11724 21.2008 8.93379C21.4366 8.09517 21.6463 7.25655 21.8822 6.41793C22.118 5.5531 21.5939 4.81931 20.7029 4.7931C19.838 4.74069 18.9732 4.68828 18.0822 4.66207C17.8725 4.66207 17.7939 4.55724 17.7415 4.4C17.4532 3.61379 17.1387 2.80138 16.8242 2.01517C16.4049 1.17654 15.5663 0.914472 14.8063 1.4124ZM10.5084 7.67585L15.7498 12.9172C15.8808 13.0483 15.9856 13.2317 16.0118 13.4152C16.0118 13.4676 16.038 13.5462 16.038 13.5986C16.038 13.8345 15.9332 14.0965 15.7498 14.28L13.6008 16.429C13.2339 16.7958 12.6311 16.7958 12.2642 16.429C11.8973 16.0621 11.8973 15.4593 12.2642 15.0924L13.7318 13.6248L9.17182 9.06481C8.80493 8.69792 8.80493 8.09516 9.17182 7.72826C9.53872 7.30895 10.1415 7.30895 10.5084 7.67585Z"
                  fill="#15AB9E"
                />
              </svg>
              Get Enquiry
            </button>
          </Link>
          <div className="flex gap-6">
            <div
              className="hidden lg:block w-1/4 bg-white p-4 h-[900px] overflow-auto  [&::-webkit-scrollbar]:w-1
                        [&::-webkit-scrollbar-track]:rounded-full
                        [&::-webkit-scrollbar-track]:bg-gray-100
                        [&::-webkit-scrollbar-thumb]:rounded-full
                        [&::-webkit-scrollbar-thumb]:bg-[#D0D0D0]
                        dark:[&::-webkit-scrollbar-track]:bg-neutral-700
                        dark:[&::-webkit-scrollbar-thumb]:bg-[#D0D0D0]
                         sticky top-28"
            >
              {/* Applied Filters */}
              {Object.entries(selectedFilters).some(
                ([key, value]) => key !== "price" && value !== null
              ) && (
                  <div className="flex justify-between items-center mb-4">
                    <h2 className=" text-[#242424]  tracking-wide text-lg font-semibold leading-normal uppercase">
                      Applied Filters
                    </h2>
                    <button
                      className="text-customGreen text-xs font-bold leading-normal underline decoration-solid [text-decoration-skip-ink:none] decoration-auto underline-offset-auto [text-underline-position:from-font] uppercase"
                      onClick={() => {
                        initProductList(clear);
                        SetOffset(0);
                        setItemOffset(0);

                        setSelectedValue("Sort By");
                        setPriceRange([
                          changePriceValue(
                            filterSortFromURl(window?.location?.search)?.startprice,
                            filterSortFromURl(window?.location?.search)?.endprice,
                            (selectedcountrySuccess?.currencyAlias
                              ? selectedcountrySuccess?.currencyAlias
                              : "") == constants.INR,
                            selectedcountrySuccess?.fxConversionRate
                          ).startprice,
                          changePriceValue(
                            filterSortFromURl(window?.location?.search)?.startprice,
                            filterSortFromURl(window?.location?.search)?.endprice,
                            (selectedcountrySuccess?.currencyAlias
                              ? selectedcountrySuccess?.currencyAlias
                              : "") == constants.INR,
                            selectedcountrySuccess?.fxConversionRate
                          ).endprice,
                        ]);
                      }}
                    >
                      Clear Filter
                    </button>
                  </div>
                )}

              {/* Display Filters (Exclude Price) */}
              {/* <div className="flex flex-wrap gap-2 mb-4">
                {Object?.entries(selectedFilters)?.map(
                  ([category, selectedItem]) =>
                    category !== "price" &&
                    selectedItem && (
                      <span
                        key={category}
                        className="flex items-center px-3 py-1 bg-[#DCF2F0] text-[#242424]  text-base font-medium rounded-full "
                      >
                        {selectedItem}
                        <button
                          className="ml-2 text-black hover:text-gray-900 text-xs font-semibold"
                          onClick={() => {
                            sorbyChange(category);
                            SetOffset(0);
                            setItemOffset(0);
                          }}
                        >
                          ✕
                        </button>
                      </span>
                    )
                )}
              </div> */}
              <div className="flex flex-wrap gap-2 mb-4 px-0">
                  {Object.entries(selectedFilters).map(([category, selectedItem]) => {
                    if (category === "undefined" || category === "price" || !selectedItem) return null;

                    // Handle array-type filters
                    if (Array.isArray(selectedItem)) {
                      return selectedItem.map((item) => (
                        item !== "" && <span
                          key={`${category}-${item}`}
                          className="flex items-center px-3 py-1 bg-[#DCF2F0] text-[#242424] text-base font-medium rounded-full"
                        >
                          {item}
                          <button
                            className="ml-2 text-gray-600 hover:text-gray-900"
                            onClick={() => sorbyChange(category, item)}
                          >
                            ✕
                          </button>
                        </span>
                      ));
                    }

                    // Handle string-type filters
                    return (
                      <span
                        key={category}
                        className="flex items-center px-3 py-1 bg-[#DCF2F0] text-[#242424] text-base font-medium rounded-full"
                      >
                        {selectedItem}
                        <button
                          className="ml-2 text-gray-600 hover:text-gray-900"
                          onClick={() => sorbyChange(category, selectedItem)}
                        >
                          ✕
                        </button>
                      </span>
                    );
                  })}
                </div>

              <div className="border border-b-customGreen border-l-0 border-r-0 border-t-0 opacity-[0.25]"></div>

              <div className="w-full mt-4">
                {/* Pricing Range Header */}
                <h2 className=" mb-2 text-[#242424]  tracking-wider text-lg font-semibold leading-normal uppercase">
                  Pricing Range
                </h2>
                <div className="flex justify-between mb-2">
                  <span className="text-[#242424] font-medium text-base">
                    {selectedcountrySuccess?.currencySymbol}{" "}
                    {priceRange[0]?.toLocaleString("en-IN")}
                  </span>
                  <span className="text-[#242424] font-medium text-base">
                    {selectedcountrySuccess?.currencySymbol}{" "}
                    {priceRange[1]?.toLocaleString("en-IN")}
                  </span>
                </div>

                {/* React-Range Slider */}
                <Range
                  step={200}
                  min={0}
                  max={
                    (selectedcountrySuccess?.currencyAlias
                      ? selectedcountrySuccess?.currencyAlias
                      : "") === constants.INR
                      ? 200000
                      : 5000
                  }
                  values={priceRange}
                  onChange={handlePriceChange}
                  onFinalChange={handleFinalPriceChange}
                  renderTrack={({ props, children }) => (
                    <div
                      {...props}
                      className="w-full h-2 bg-[#EEEEEE] rounded relative z-[1]"
                    >
                      <div
                        className="absolute h-2 bg-teal-500 rounded"
                        style={{
                          left: `${((priceRange[0] - 100) /
                              (((selectedcountrySuccess?.currencyAlias
                                ? selectedcountrySuccess?.currencyAlias
                                : "") === constants.INR
                                ? 200000
                                : 5000) -
                                100)) *
                            100
                            }%`,
                          right: `${100 -
                            ((priceRange[1] - 100) /
                              (((selectedcountrySuccess?.currencyAlias
                                ? selectedcountrySuccess?.currencyAlias
                                : "") === constants.INR
                                ? 200000
                                : 5000) -
                                100)) *
                            100
                            }%`,
                        }}
                      />
                      {children}
                    </div>
                  )}
                  renderThumb={({ props }) => (
                    <div
                      {...props}
                      className="w-5 h-5 bg-white border-[5px] border-customGreen rounded-full shadow cursor-pointer focus:outline-none"
                    />
                  )}
                />
              </div>

              <div className="border border-b-customGreen border-l-0 border-r-0 border-t-0 opacity-[0.25] mt-6 mb-3"></div>

              {/* Filter Categories */}
              <div className="">
                {filterList?.slice(0, 6)?.map((filterCategory) => (
                  <div key={filterCategory}>
                    {/* Collapsible Section Header */}

                    <div
                      className="flex justify-between items-center cursor-pointer py-2 text-lg font-semibold"
                      onClick={() => toggleCategory(filterCategory)}
                    >
                      <span className="text-[#242424] tracking-wider text-lg font-semibold leading-normal uppercase">
                        {filterCategory}
                      </span>
                      <span className="text-gray-500">
                        {expandedCategories.includes(filterCategory) ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="w-5 h-5"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M5 15l7-7 7 7"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="w-5 h-5"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        )}
                      </span>
                    </div>

                    {/* Filter Options */}
                    {expandedCategories.includes(filterCategory) && (
                      <div className="space-y-2 mt-2">
                        {filters[filterCategory]?.map((option, idx) => (
                          <>
                            <label
                              key={idx}
                              className="flex items-center space-x-2"
                            >
                              <input
                                type="checkbox"
                                className={`w-5 h-5 rounded border border-gray-400 bg-white checked:bg-gradient-to-r from-customGreen to-[#00867A] checked:border-customGreen text-white appearance-none checked:after:content-['✓'] checked:after:text-white checked:after:flex checked:after:justify-center checked:after:items-center checked:after:w-full checked:after:h-full`}
                                onChange={() =>
                                  handleFilterChange(filterCategory, option.name)
                                }
                                // checked={
                                //   selectedFilters[filterCategory] ===
                                //   option.name || false
                                // }
                                checked={
                                  (selectedFilters[filterCategory]?.includes(option.name)) || false
                                }
                              />
                              <span className="text-[#242424] text-base font-medium leading-relaxed">
                                {option.name}
                              </span>
                            </label>
                          </>
                        ))}
                      </div>
                    )}
                    <div className="border border-b-customGreen border-l-0 border-r-0 border-t-0 opacity-[0.25] mt-2 mb-2"></div>
                  </div>
                ))}
              </div>
            </div>

            <div className="lg:w-3/4 w-full flex flex-col items-center">
              {productsToDisplay?.length !== 0 &&
                productListLoading.current &&
                getSeoData !== null ? (
                <div className="lg:grid lg:grid-cols-3 lg:gap-6 grid grid-cols-2 gap-2 pb-10">
                  {productsToDisplay?.map((product) => {
                    const {
                      productName,
                      productId,
                      trans_sku_lists,
                      productImagesByProductId,
                      selling_qty,
                      is_featured,
                    } = product;
                    const productImage =
                      productImagesByProductId[0]?.imageUrl ||
                      constants.DEFAULT_NO_PRODUCT_IMAGE;
                    const productUrl = trans_sku_lists[0]?.skuUrl || "#";
                    const sellingPrice =
                      trans_sku_lists[0]?.markupPrice;
                    const discount_price = trans_sku_lists[0]?.discountPrice;
                    const discount = trans_sku_lists[0]?.discount || null;

                    // Determine if the product is liked
                    const isLiked = likedProducts[productId] || false;

                    return (
                      <div
                        key={product.productId}
                        className="relative bg-white block transition duration-300"
                      >
                        {/* Best Seller Badge */}
                        {selling_qty && (
                          <div className="absolute left-3 rounded-br-xl rounded-bl-xl bg-gradient-to-r pb-1 px-4 from-[#0B34D9] to-[#1699EB] text-white text-base font-semibold leading-normal">
                            Best Seller
                          </div>
                        )}

                        {/* Wishlist Button */}
                        <button
                          onClick={() => {
                            handleAddToWishlist(
                              trans_sku_lists[0]?.generatedSku, // Assuming this is the correct SKU
                              product.productId
                            );
                          }}
                          className="absolute top-2 right-2 text-white hover:text-red-500 focus:outline-none transition-colors duration-300"
                          aria-label="Add to Wishlist"
                        >
                          <img
                            src={
                              isLiked
                                ? constants.DEFAULT_IMAGE + "/heart-filled.svg"
                                : constants.DEFAULT_IMAGE + "/heart-outline.svg"
                            }
                            alt="Wishlist"
                            className="w-6 h-6 transition-all duration-300"
                          />
                        </button>

                        {/* Product Image and Details */}
                        <a href={productUrl} className="block mb-2">
                          <div className="w-full overflow-hidden">
                            <img
                              src={getImage(productImage, "700X700")}
                              alt={productName}
                              className="w-full h-full object-cover"
                            />
                          </div>
                          <h3 className="text-base leading-5 font-medium text-center mt-1">
                            {descriptionShow(productName)}
                            {/* { isMobile && isTablet && productName.length > 15 ? productName?.slice(0,14)+"..":productName} */}
                            {/* { !isMobile && !isTablet && productName.length > 26 ? productName?.slice(0,26)+"..":productName} */}
                          </h3>
                          <p className="text-[#676767] text-center font-medium text-sm">
                            {sellingPrice !== discount_price && (<span className="line-through">{formatCurrencywithamount(
                              discount_price,
                              selectedcountrySuccess?.currencyAlias
                                ? selectedcountrySuccess?.currencyAlias
                                : "",
                              selectedcountrySuccess?.iso
                                ? `en-${selectedcountrySuccess?.iso}`
                                : "",
                              dailyMetalPriceSuccess?.data?.allMasterCountries
                                ?.nodes
                            )}</span>)}&nbsp;
                            {formatCurrencywithamount(
                              sellingPrice,
                              selectedcountrySuccess?.currencyAlias
                                ? selectedcountrySuccess?.currencyAlias
                                : "",
                              selectedcountrySuccess?.iso
                                ? `en-${selectedcountrySuccess?.iso}`
                                : "",
                              dailyMetalPriceSuccess?.data?.allMasterCountries
                                ?.nodes
                            )}&nbsp;

                            {(discount && discount !== '0') && (
                              <span>
                                ({discount}% - OFF)
                              </span>
                            )}
                          </p>
                        </a>
                      </div>
                    );
                  })}
                </div>
              ) : (productListitemsResponesLoading ||
                !productListLoading.current) &&
                getSeoData !== null ? (
                <div className="text-center py-6 flex flex-col items-center">
                  {/* SVG Image from Path */}
                  <img
                    src={constants.DEFAULT_IMAGE + "/loaderimagesilver.gif"}
                    alt="loading logo"
                    className="w-120 h-120"
                  />
                </div>
              ) : (
                productsToDisplay?.length === 0 && (
                  <div className="text-center py-6 flex flex-col items-center">
                    {/* SVG Image from Path */}
                    <img
                      src={constants.DEFAULT_IMAGE + "/no-product.svg"}
                      alt="Sorry, No Product Found"
                      className="w-120 h-120"
                    />
                    <p className="text-xl font-semibold text-[#262626]">
                      Sorry, No Product Found
                    </p>
                  </div>
                )
              )}

              {/* pagination ==============================> */}

              <div className="w-auto flex justify-content-center">
                {productsToDisplay?.length !== 0 &&
                  productListLoading.current &&
                  (apiTotalCount / limit > 1 ? (
                    <ReactPaginate
                      previousLabel="<"
                      nextLabel=">"
                      pageClassName="page-item"
                      pageLinkClassName="page-link"
                      previousClassName="page-item"
                      previousLinkClassName="page-link"
                      nextLinkClassName="page-link"
                      nextClassName="page-item"
                      breakLabel="..."
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                      pageCount={Math.ceil(apiTotalCount / limit)}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={2}
                      onPageChange={handlePageClick}
                      containerClassName="pagination flex flex-wrap justify-center gap-2"
                      activeClassName="active"
                      forcePage={itemOffset}
                      disabledClassName="opacity-50 cursor-not-allowed"
                    />
                  ) : (
                    <p className="text-[24px] font-semibold underline decoration-[#06ab9f] text-black">
                      1
                    </p>
                  ))}
                {/* pagenation ==============================> */}
                {/* {productsToDisplay?.length !== 0 &&
                productListLoading.current &&
                (apiTotalCount / limit > 1 ? (
                  <ReactPaginate
                    previousLabel="<"
                    nextLabel=">"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextLinkClassName="page-link"
                    nextClassName={`page-item ${
                      itemOffset + limit >= apiTotalCount ? "hidden" : ""
                    }`}
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    pageCount={Math.ceil(apiTotalCount / limit)}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={2}
                    onPageChange={handlePageClick}
                    containerClassName="pagination"
                    activeClassName="active"
                    forcePage={itemOffset}
                  />
                ) : (
                  <p className="text-[24px]  font-semibold underline decoration-[#06ab9f] text-black">
                    1
                  </p>
                ))} */}
              </div>

              <div className="flex lg:flex-col items-end gap-4 justify-center mb-5 lg:hidden sticky bottom-0 mt-8 bg-white p-4 shadow-top-only">
                <div className="space-y-4 border w-[150px] bg-white border-customGreen lg:hidden block">
                  <div
                    className="flex px-4 py-[10px] justify-start gap-3"
                    onClick={openModal}
                  >
                    <img src={constants.DEFAULT_IMAGE + "/filter.svg"} />
                    <p className="font-medium text-sm text-[#242424]">Filters</p>
                  </div>
                </div>

                <div className="relative">
                  <select
                    value={selectedValue}
                    onChange={handleChange}
                    className="appearance-none w-[150px] px-4 py-2 border border-customGreen shadow-sm focus:outline-none focus:ring-2 focus:ring-customGreen focus:border-customGreen pr-10 bg-white"
                  >
                    <option disabled className=" text-black">
                      Sort By
                    </option>
                    {filterList?.slice(6, 7)?.map((filterCategory) =>
                      filters[filterCategory]?.map((option, idx) => (
                        <option key={idx} value={option.name}>
                          {option.name}
                        </option>
                      ))
                    )}
                  </select>
                  <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                    <img
                      src={
                        constants.DEFAULT_IMAGE + "/product_care_accortian_down.png"
                      }
                      className="w-4"
                    />
                  </div>
                </div>
              </div>
            </div>



            {/* Mobile Filters */}
            <Modal
              isOpen={modalIsOpen}
              onAfterOpen={afterOpenModal}
              onRequestClose={closeModal}
              style={customStyles}
              contentLabel="Example Modal"
            >
              <div className="flex justify-between items-center pb-5 bg-white pt-8 z-[1] px-4 sticky top-0">
                {Object.entries(selectedFilters).some(
                  ([key, value]) => key !== "price" && value !== null
                ) && (
                    <div className="">
                      <h2 className=" text-[#242424]  text-lg font-semibold leading-normal uppercase">
                        Applied Filters
                      </h2>
                    </div>
                  )}
                <button onClick={closeModal} className="absolute right-3">
                  <img src={constants.DEFAULT_IMAGE + "/close.svg"} />
                </button>
              </div>

              {/* Display Filters (Exclude Price) */}
              <div className="bg-white sticky top-[79px] z-[1] w-full">
                {/* <div className="flex flex-wrap gap-2 mb-4 px-4">
                  {Object?.entries(selectedFilters)?.map(
                    ([category, selectedItem]) =>
                      category !== "price" &&
                      selectedItem && (
                        <span
                          key={category}
                          className="flex items-center px-3 py-1 bg-[#DCF2F0] text-[#242424]  text-base font-medium rounded-full "
                        >
                          {selectedItem}
                          <button
                            className="ml-2 text-gray-600 hover:text-gray-900"
                            onClick={() => {
                              sorbyChange(category, "mobile");
                            }}
                          >
                            ✕
                          </button>
                        </span>
                      )
                  )}
                </div> */}
                <div className="flex flex-wrap gap-2 mb-4 px-4">
                  {Object.entries(selectedFilters).map(([category, selectedItem]) => {
                    if (category === "undefined" || category === "price" || !selectedItem) return null;

                    // Handle array-type filters
                    if (Array.isArray(selectedItem)) {
                      return selectedItem.map((item) => (
                        item !== "" && <span
                          key={`${category}-${item}`}
                          className="flex items-center px-3 py-1 bg-[#DCF2F0] text-[#242424] text-base font-medium rounded-full"
                        >
                          {item}
                          <button
                            className="ml-2 text-gray-600 hover:text-gray-900"
                            onClick={() => sorbyChange(category, item)}
                          >
                            ✕
                          </button>
                        </span>
                      ));
                    }

                    // Handle string-type filters
                    return (
                      <span
                        key={category}
                        className="flex items-center px-3 py-1 bg-[#DCF2F0] text-[#242424] text-base font-medium rounded-full"
                      >
                        {selectedItem}
                        <button
                          className="ml-2 text-gray-600 hover:text-gray-900"
                          onClick={() => sorbyChange(category, selectedItem)}
                        >
                          ✕
                        </button>
                      </span>
                    );
                  })}
                </div>

                <div className="border border-b-customGreen border-l-0 border-r-0 border-t-0 opacity-[0.25]"></div>
              </div>
              <div className="w-full mt-8 px-4">
                {/* Pricing Range Header */}
                <h2 className=" mb-2 text-[#242424]  text-lg font-semibold leading-normal uppercase">
                  Pricing Range
                </h2>
                <div className="flex justify-between text-sm text-gray-700 mb-2">
                  <span>
                    {selectedcountrySuccess?.currencySymbol}{" "}
                    {priceRange[0]?.toLocaleString("en-IN")}
                  </span>
                  <span>
                    {selectedcountrySuccess?.currencySymbol}{" "}
                    {priceRange[1]?.toLocaleString("en-IN")}
                  </span>
                </div>
              </div>
              {/* React-Range Slider */}
              <Range
                step={100}
                min={0}
                max={
                  (selectedcountrySuccess?.currencyAlias
                    ? selectedcountrySuccess?.currencyAlias
                    : "") === constants.INR
                    ? 200000
                    : 5000
                }
                values={priceRange}
                onChange={handlePriceChange}
                onFinalChange={handleFinalPriceChange}
                renderTrack={({ props, children }) => (
                  <div
                    {...props}
                    className="w-full h-2 bg-[#EEEEEE] rounded relative price-slider"
                  >
                    <div
                      className="absolute h-2 bg-teal-500 rounded"
                      style={{
                        left: `${((priceRange[0] - 100) /
                            (((selectedcountrySuccess?.currencyAlias
                              ? selectedcountrySuccess?.currencyAlias
                              : "") === constants.INR
                              ? 200000
                              : 5000) -
                              100)) *
                          100
                          }%`,
                        right: `${100 -
                          ((priceRange[1] - 100) /
                            (((selectedcountrySuccess?.currencyAlias
                              ? selectedcountrySuccess?.currencyAlias
                              : "") === constants.INR
                              ? 200000
                              : 5000) -
                              100)) *
                          100
                          }%`,
                      }}
                    />
                    {children}
                  </div>
                )}
                renderThumb={({ props }) => (
                  <div
                    {...props}
                    className="w-5 h-5 bg-white border-[5px] border-customGreen rounded-full shadow cursor-pointer focus:outline-none"
                  />
                )}
              />

              <div className="border border-b-customGreen border-l-0 border-r-0 border-t-0 opacity-[0.25] mt-6 mb-3"></div>



              {/* Filter Categories */}
              <div className="">
                {filterList?.slice(0, 6)?.map((filterCategory) => (
                  <div key={filterCategory}>
                    {/* Collapsible Section Header */}

                    <div
                      className="flex justify-between items-center cursor-pointer py-2 text-lg font-semibold px-4"
                      onClick={() => toggleCategory(filterCategory)}
                    >
                      <span className="text-[#242424]  text-lg font-semibold leading-normal uppercase">
                        {filterCategory}
                      </span>
                      <span className="text-gray-500">
                        {expandedCategories.includes(filterCategory) ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="w-5 h-5"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M5 15l7-7 7 7"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="w-5 h-5"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        )}
                      </span>
                    </div>

                    {/* Filter Options */}
                    {expandedCategories.includes(filterCategory) && (
                      <div className="space-y-2 mt-2 px-4">
                        {filters[filterCategory]?.map((option, idx) => (
                          <>
                            <label
                              key={idx}
                              className="flex items-center space-x-2"
                            >
                              <input
                                type="checkbox"
                                className={`w-5 h-5 rounded border border-gray-400 bg-white checked:bg-gradient-to-r from-customGreen to-[#00867A] checked:border-customGreen text-white appearance-none checked:after:content-['✓'] checked:after:text-white checked:after:flex checked:after:justify-center checked:after:items-center checked:after:w-full checked:after:h-full`}
                                onChange={() =>
                                  handleFilterChange(filterCategory, option.name)
                                }
                                // checked={
                                //   selectedFilters[filterCategory] ===
                                //   option.name || false
                                // }
                                checked={
                                  (selectedFilters[filterCategory]?.includes(option.name)) || false
                                }
                              />
                              <span className="text-[#242424] text-base font-medium leading-relaxed">
                                {option.name}
                              </span>
                            </label>
                          </>
                        ))}
                      </div>
                    )}
                  </div>
                ))}

              </div>
              <div className="flex gap-3 justify-between pt-4 pb-4 sticky bottom-0 bg-white px-4">
                <button
                  className="text-customGreen border border-customGreen text-xs font-bold leading-normal [text-decoration-skip-ink:none] decoration-auto underline-offset-auto [text-underline-position:from-font] uppercase px-8 py-2"
                  onClick={() => {
                    setPriceRange([
                      changePriceValue(
                        filterSortFromURl(window?.location?.search)?.startprice,
                        filterSortFromURl(window?.location?.search)?.endprice,
                        (selectedcountrySuccess?.currencyAlias
                          ? selectedcountrySuccess?.currencyAlias
                          : "") == constants.INR,
                        selectedcountrySuccess?.fxConversionRate
                      ).startprice,
                      changePriceValue(
                        filterSortFromURl(window?.location?.search)?.startprice,
                        filterSortFromURl(window?.location?.search)?.endprice,
                        (selectedcountrySuccess?.currencyAlias
                          ? selectedcountrySuccess?.currencyAlias
                          : "") == constants.INR,
                        selectedcountrySuccess?.fxConversionRate
                      ).endprice,
                    ]);
                    //window.location.replace(constants.ADDITIONAL_PATH+constants.CLEAR_FILTER_REDIRECT_PATH);
                    SetOffset(0);
                    setItemOffset(0);

                    setSelectedValue("Sort By");
                    Object.keys(selectedFilters).length > 0 &&
                      isMobileFilter &&
                      initProductList(clear);
                  }}
                >
                  Clear Filter
                </button>
                <button
                  className="text-white bg-customGreen border border-customGreen text-xs font-bold leading-normal [text-decoration-skip-ink:none] decoration-auto underline-offset-auto [text-underline-position:from-font] uppercase px-8 py-2"
                  onClick={() => {
                    if (
                      Object.keys(selectedFilters).length > 0 &&
                      isMobileFilter
                    ) {
                      initProductList();
                      productListLoading.current = true;
                    } else {
                      // alert("no filter");
                    }
                    SetOffset(0);
                    setItemOffset(0);
                  }}
                >
                  Show Results
                </button>
              </div>
            </Modal>
          </div>
          {/* {showImage && <div className="border fixed right-9 bottom-40 z-0 bg-white rounded-full w-10 h-10 hover:shadow-md">
          <img src={ constants.DEFAULT_IMAGE + "/top-arrow.svg" } className="w-10 h-10 p-3 transition-opacity duration-300" onClick={()=>window.scrollTo({ top: 0, behavior: 'smooth' })} />
        </div>} */}
        </div>
      </body></>
  );
}

export default ProductList;
